import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const accordionDetails = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiAccordionDetails"] => ({
	root: {
		padding: spacing(3),
	},
});

export default accordionDetails;
